export default __webpack_public_path__ + "static/media/Geysers.f494730f.webp";